import { useTranslation } from 'react-i18next';
import { isCn } from '@/lib/captcha-config';

export function AuthFooter() {
  const { t } = useTranslation('knox-aiops');

  return (
    <footer className="shrink-0 w-full bg-white">
      <div className="mx-auto flex w-full max-w-7xl flex-col items-center gap-2 px-8 py-4">
        <span className="text-[0.6875rem] uppercase tracking-widest text-muted-foreground/60">
          {t('login.copyright')}
          {isCn() && (
            <>
              <span className="mx-1">|</span>
              <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer" className="text-[0.6875rem] tracking-widest text-muted-foreground/40 transition-colors hover:text-primary hover:underline underline-offset-4">粤ICP备15047819号-10</a>
            </>
          )}
        </span>
        <div className="flex gap-6">
          <a href="/terms" className="text-[0.6875rem] uppercase tracking-widest text-muted-foreground/40 transition-colors hover:text-primary hover:underline underline-offset-4">{t('login.termsOfService')}</a>
          <a href="/privacy" className="text-[0.6875rem] uppercase tracking-widest text-muted-foreground/40 transition-colors hover:text-primary hover:underline underline-offset-4">{t('login.privacyPolicy')}</a>
          {isCn() && <a href="/refund" className="text-[0.6875rem] uppercase tracking-widest text-muted-foreground/40 transition-colors hover:text-primary hover:underline underline-offset-4">{t('login.refundPolicy')}</a>}
        </div>
        {!isCn() && (
          <p className="text-[0.625rem] text-muted-foreground/40 text-center">
            Protected by reCAPTCHA —{' '}
            <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer" className="underline underline-offset-2 hover:text-muted-foreground/60">Privacy</a>
            {' & '}
            <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer" className="underline underline-offset-2 hover:text-muted-foreground/60">Terms</a>
          </p>
        )}
      </div>
    </footer>
  );
}
